import { hooks, site, blocks } from '@yola/ws-sdk';
import constants from '../constants';
import trackEvent from './track-event';

const trackBlockAdded = () => {
  hooks.operations.subscribe(
    hooks.availableHooks.ON_AFTER_BLOCK_ADDED,
    ({ blockId, variationId: blockVariationId }) => {
      if (!blockId) return;

      const isBlockWidget = blockId.startsWith('widget-');
      if (isBlockWidget) return;

      const block = blocks.accessors.getBlock(blockId);

      trackEvent(constants.events.BLOCK_ADDED, {
        pageId: site.accessors.getActivePageId(),
        blockId,
        blockVariationId,
        premiumBlock: !!block.premium,
      });
    }
  );
};

export default trackBlockAdded;
